import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const PAGE_MENU: PermissionTableRowType = {
  name: '페이지',
  key: 'PAGE_MANAGE',
  subRows: [
    {
      name: '메인 페이지 관리',
      key: PERMISSION_SUBJECTS.MAIN_PAGE,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.UPDATE],
    },
    {
      name: '서브 페이지 관리',
      key: PERMISSION_SUBJECTS.SUB_PAGE,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DELETE,
      ],
    },
    {
      name: '위젯 관리',
      key: PERMISSION_SUBJECTS.WIDGET,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DELETE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.WIDGET,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '위젯 등록',
          key: PERMISSION_SUBJECTS.WIDGET,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '위젯 편집',
          key: PERMISSION_SUBJECTS.WIDGET,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '위젯 삭제',
          key: PERMISSION_SUBJECTS.WIDGET,
          permissions: [PERMISSION_ACTIONS.DELETE],
        },
      ],
    },
    {
      name: '홈 탭 & 메뉴 관리',
      key: PERMISSION_SUBJECTS.MENU,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.CREATE, PERMISSION_ACTIONS.UPDATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.MENU,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '등록',
          key: PERMISSION_SUBJECTS.MENU,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '편집',
          key: PERMISSION_SUBJECTS.MENU,
          permissions: [PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
